<template>
  <!--列表功能模板-->
    <el-row :gutter="4" class="h100">
        <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                v-loading="showList && treeLoading">
            <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="showList = !showList"></div>
            <el-menu class="h100 metadataTree" :default-active="searchForm.messageClassification" @select="selectMenu">
                <el-menu-item :index="item.value" v-for="item in basicDataList" :key="item.value">
                    <span slot="title">{{ item.label }}</span>
                </el-menu-item>
            </el-menu>
        </el-col>
        <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
            <div class="el-table-container">
                <el-form size="small" inline class="query-form" ref="searchForm" :model="searchForm"
                         label-width="100px" @keyup.enter.native="refreshList(1)">
                    <el-form-item prop="messageContent" label="关键字：">
                        <el-input v-model.trim="searchForm.messageContent" maxlength="100"
                                  placeholder="关键字搜索"
                                  clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="messageType" label="消息类型：">
                        <el-select v-model="searchForm.messageType" clearable placeholder="请选择消息类型">
                            <el-option
                                    v-for="item in $dictUtils.getDictList('message_type')"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                        </el-button>
                        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                    </el-form-item>
                    <el-form-item class="f_r">
                        <el-button v-if="hasPermission('sys:mageCenter:mageCenter:read')" type="primary"
                                   @click="allRead()" size="small">全部已读
                        </el-button>
                        <el-button v-if="hasPermission('sys:mageCenter:mageCenter:deleteData')" type="primary"
                                   @click="deleteColumn()" size="small">批量删除
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="tips">
                    <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
                    已选择{{ dataListSelections.length }}项数据
                </div>
                <el-table
                        :data="dataList"
                        size="small" height="100%"
                        class="table" ref="multipleTable" border
                        @selection-change="selectionChangeHandle" row-key='id' v-loading="loading"
                        @sort-change="sortChangeHandle"
                >
                    <el-table-column type="selection" :reserve-selection='true' fixed/>
                    <el-table-column prop="messageTitle" label="消息标题" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <div class="flex_l_c">
                                <div class="unread">
                                    <div v-show="row.messageStatus == '未读'"></div>
                                </div>
                                <div class="omit" style="width: 100%">{{ row.messageTitle }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="messageContent" label="消息内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="messageType" label="消息类型" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <div>{{ $dictUtils.getDictLabel("message_type", row.messageType, '') }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="messageStatus" label="状态" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="messageData" sortable="custom" label="发送时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="100">
                        <template slot-scope="{row,$index}">
                            <el-button v-if="hasPermission('sys:mageCenter:mageCenter:detail')" type="text" size="small"
                                       @click="detailData(row,$index)">查看
                            </el-button>
                            <el-button v-if="hasPermission('sys:mageCenter:mageCenter:deleteData')" type="text"
                                       size="small" @click="deleteColumn(row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                            @pagination="refreshList"/>
            </div>
        </el-col>
        <see-message ref="seeMessage" @refresh="refreshList('',1)" @switchData="switchDetail"></see-message>
    </el-row>
</template>

<script>
import SeeMessage from "@/views/modules/sys/mageCenter/seeMessage.vue";
import RemoveLabel from "@/components/resourcesLabel/removeLabel.vue";

export default {
    components: {SeeMessage},
    data() {
        return {
            treeLoading: false,
            showList: true,
            basicDataList: [],
            searchForm: {
                messageClassification: '', //选择的id
                messageContent: '',
                messageType: '',
                current: 1,
                size: 20,
            },
            sort:'',
            basicDataInfo: {},
            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            detailCurr: 0,
        }
    },
    mounted() {
        this.getField()
    },
    methods: {
        // 获取字段
        getField() {
            this.basicDataList = this.$dictUtils.getDictList('sys_menu_local_system')
            this.selectMenu(this.basicDataList[0].value)
        },

        // 选择树节点
        selectMenu(val) {
            this.searchForm.messageClassification = val
            this.reset()
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.$nextTick(() => {
                this.refreshList(1, 3)
            })
        },

        // 获取数据列表
        refreshList(current, clearSelect) {
            if (current == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.allCommon.commonMessageSelectMessageList, {
                ...this.searchForm,
                sort:this.sort,
            }).then(data => {
                if (data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        //全部已读
        allRead() {
            this.$confirm(`您是否确认消息全部已读?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.allCommon.commonMessageBatchRead, [], 'post').then(data => {
                    if (data.status) {
                        this.$message.success('全部已读成功');
                        this.refreshList('', 1)
                        //更新我的未读信息
                        this.$store.commit('user/updateUserMessage')
                    } else {
                        this.$message.error(data.msg);
                    }
                })
            })
        },

        //排序
        sortChangeHandle (obj) {
            console.log(obj)
            if (obj.order){
                if (obj.prop == "messageData"){
                    this.sort = 'message_data'
                }
                if (obj.order === 'ascending') {
                    this.sort += ' asc'
                }else {
                    this.sort += ' desc'
                }
            }else {
                this.sort = ''
            }
            this.refreshList(1)
        },

        //删除
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelections
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.allCommon.commonMessageRemoveById, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //查看
        detailData(row, index) {
            this.detailCurr = (this.searchForm.current - 1) * this.searchForm.size + index + 1
            this.$refs.seeMessage.init(row)
        },

        //详情 0上一条 1下一条切换
        switchDetail(num) {
            if (num == 0 && this.detailCurr == 1) {
                this.$message('已是第一条')
                return
            }
            if (num == 1 && (this.detailCurr) == this.total) {
                this.$message('已是最后一条')
                return
            }
            if (num == 0) {
                this.detailCurr--
            } else {
                this.detailCurr++
            }
            this.$axios(this.api.allCommon.commonMessageSelectMessageList, {
                ...this.searchForm,
                current: this.detailCurr,
                size: 1,
            }).then(data => {
                if (data.status) {
                    this.$refs.seeMessage.init(data.data.records[0])
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
    },
}
</script>

<style scoped lang="scss">
.metadataTree {
  background: #ffffff;
}

.el-menu {
  border-right: none !important;
}

.el-menu-item, .el-submenu__title {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 14px;
}

.dynamicForm {
  max-height: 74px;
  overflow-y: auto;

  .el-form-item {
    display: inline-block;
    width: 49% !important;
  }
}

.tips {
  padding: 4px;

  .el-icon-info {
    margin-right: 6px;
  }
}

.unread {
  width: 20px;
  text-align: center;

  div {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: red;
    margin-right: 8px;
  }
}
</style>
